export const closePageViewer = viewer => ({
  type: "CLOSE_PAGE_VIEWER",
  viewer
});

export const openPageViewer = viewer => ({
  type: "OPEN_PAGE_VIEWER",
  viewer
});

export const setCurrentPage = page => ({
  type: "SET_CURRENT_PAGE_VIEWER",
  page: page
});



// WEBPACK FOOTER //
// ./src/actions/actions/page-viewer.js